module.exports = __webpack_public_path__ + "img/cocos-island.ca5a5dcd.png";